export const LANGUAGE_PILL_TRIGGER_CLASS =
  'inline-flex h-8 shrink-0 items-center gap-1 rounded-full border border-border/60 bg-background/60 px-2.5 text-xs font-medium text-foreground/80 transition hover:bg-accent hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring';
